export default "__VITE_ASSET__CxC1IBYs__"